<span [matTooltip]="truncated ? value : null"
  >{{ displayed }}
  @if (truncated) {
    <span>...</span>
  }
</span>
